import { useAuth } from '../context/AuthContext.jsx';

export default function TopBar({ title = 'XM: Evolution Feedback Dashboard' }) {
  const { user, logout } = useAuth();
  return (
    <header className="topbar">
      <div className="topbar__title">{title}</div>
      <div className="topbar__user">
        <div>
          <div className="topbar__user-name">{user?.full_name || user?.email || ''}</div>
          <div className="topbar__user-role">{user?.role || ''}</div>
        </div>
        <button className="btn btn--secondary" onClick={logout}>
          Sign out
        </button>
      </div>
    </header>
  );
}
